// extracted by mini-css-extract-plugin
module.exports = {"impressions":"impressions-module--impressions--lCflK","impression":"impressions-module--impression--1EIIV","impressionIcon":"impressions-module--impressionIcon--3LxGX"};